import { Directive, ElementRef, Injector, Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  selector: 'bulk-actions',
  standalone: false
})
export class BulkActionsDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('bulkActionsComponent', elementRef, injector);
  }
}

@Component({
  selector: 'bulk-actions-component',
  template: '<bulk-actions></bulk-actions>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BulkActionsComponent {
  constructor() {}
}

@Directive({
  selector: 'bulk-action-create-or-edit',
  standalone: false
})
export class BulkActionCreateOrEditDirective extends UpgradeComponent {
  @Input() bulkActionId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('bulkActionCreateOrEditComponent', elementRef, injector);
  }
}

@Component({
  selector: 'bulk-action-create-or-edit-component',
  template: '<bulk-action-create-or-edit [bulkActionId]="bulkActionId"></bulk-action-create-or-edit>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BulkActionCreateOrEditComponent {
  @Input() bulkActionId: string;
}

@Directive({
  selector: 'bulk-action-view',
  standalone: false
})
export class BulkActionViewDirective extends UpgradeComponent {
  @Input() bulkActionId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('bulkActionViewComponent', elementRef, injector);
  }
}

@Component({
  selector: 'bulk-action-view-component',
  template: '<bulk-action-view [bulkActionId]="bulkActionId"></bulk-action-view>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BulkActionViewComponent {
  @Input() bulkActionId: string;
}
